/**
 * Am identity function with sole purpose to mark an array as readonly while
 * inferring the array's contained type.
 */
export const inferReadonlyArray = <T>(arr: Array<T>): ReadonlyArray<T> => arr;
